const OmniChannelFloatingIncomingCall = (props: any) => {
  return (
    <div className="cursor-pointer fixed top-16 right-0 bg-gray-900 text-white w-[248px] h-[108px] rounded-lg shadow-lg z-50">
      <div className="text-2xl font-semibold pl-6 pt-6">{props?.customerNumber}</div>
      <div className="text-base italic pl-6">Đang gọi đến</div>
    </div>
  );
};

export default OmniChannelFloatingIncomingCall;